import InstitutionDetail from '@/apps/InstitutionDetail'
import Layout from '@/apps/layout/components'
import React from 'react'

const InstitutionDetailPage = (): React.ReactElement => {
  return (
    <Layout>
      <InstitutionDetail />
    </Layout>
  )
}

export default InstitutionDetailPage
